import request from '@/utils/request'

// 获取跨组织调拨主表信息
export function coopCotCreateHead(businessId) {
  return request({
    url: `/api/coop/coopCrossOrgAllotHead/selectSuppById/${businessId}`,
    method: 'get'
  })
}

// 获取调拨物料明细
export function selectDetail(businessId) {
  return request({
    url: `/api/coop/coopCrossOrgAllotItem/selectDatas/${businessId}`,
    method: 'get'
  })
}
